import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface InvitationLinkListingCardProps {
  resources: Array<{ name: string; active: boolean }>;
}

export const InvitationLinkListingCard = ({
  resources,
}: InvitationLinkListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.invitation_links")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_links_found")}
    renderItem={link => link.name}
    getItemKey={link => link.name}
  />
);
